"use client"

import { useEffect } from "react"

export default function ScrollAnimation() {
  useEffect(() => {
    const handleScroll = () => {
      const scrollElements = document.querySelectorAll(".scroll-reveal")
      const staggeredElements = document.querySelectorAll(".staggered-fade-in")
      const slideLeftElements = document.querySelectorAll(".slide-in-left")
      const slideRightElements = document.querySelectorAll(".slide-in-right")

      const windowHeight = window.innerHeight

      // Handle basic scroll reveal animations
      scrollElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        if (elementTop < windowHeight * 0.85) {
          element.classList.add("active")
        } else {
          element.classList.remove("active")
        }
      })

      // Handle staggered fade-in animations
      staggeredElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        if (elementTop < windowHeight * 0.85) {
          element.classList.add("active")
        } else {
          element.classList.remove("active")
        }
      })

      // Handle slide-in animations
      slideLeftElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        if (elementTop < windowHeight * 0.85) {
          element.classList.add("active")
        } else {
          element.classList.remove("active")
        }
      })

      slideRightElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        if (elementTop < windowHeight * 0.85) {
          element.classList.add("active")
        } else {
          element.classList.remove("active")
        }
      })
    }

    // Initial check on load
    handleScroll()

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return null
}
